module.exports = __webpack_public_path__ + "static/media/delete_azul.02a62351.svg";